import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigationFinancialAccountCooperation = () => {
  deeplinkNavigation({
    name: 'FinancialAccountCooperation',
  })
}
